import type {
  BatMetadataConfigEntry,
  FieldMetadataMessageDescriptorDef,
} from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { allCleanPowerFields } from './common/cleanPowerFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';

const buildingAreaQuantity: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Area times months',
    context:
      'The area of the facility multiplied by the number of months it was active.',
  }),
  externalDescription: msg({
    message:
      'The area of the facility multiplied by the number of months it was active.',
    context: 'Area times months',
  }),
};

export const buildingOccupationMetadata = {
  displayName: msg({
    message: 'Facilities occupancy',
    context: 'Activity data schema name for facilities occupancy',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...buildingCommonFields,
    ...allCleanPowerFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    building_area_quantity: buildingAreaQuantity,
    // NOTE: quantity does not exist on the BAT but building_area_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: buildingAreaQuantity,
    building_area_unit: {
      displayName: msg({
        message: 'Area unit',
        context: 'The display name for a dimension',
      }),
    },
    is_building_empty: {
      displayName: msg({
        message: 'Is facility empty',
        context:
          'Indicator of whether the facility is empty during the measurement period.',
      }),
      externalDescription: msg({
        message:
          'Indicator of whether the facility is empty during the measurement period.',
        context: 'Is facility empty',
      }),
    },
    is_building_without_natural_gas: {
      displayName: msg({
        message: 'No natural gas usage',
        context: 'Indicator of whether the facility does not use natural gas.',
      }),
      externalDescription: msg({
        message: 'Indicator of whether the facility does not use natural gas.',
        context: 'No natural gas usage',
      }),
    },
    is_building_without_refrigerants: {
      displayName: msg({
        message: 'No refrigerant usage',
        context: 'Indicator of whether the facility does not use refrigerants.',
      }),
      externalDescription: msg({
        message: 'Indicator of whether the facility does not use refrigerants.',
        context: 'No refrigerant usage',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
